import { render, staticRenderFns } from "./AjusteVerbaList.vue?vue&type=template&id=b9252cce&"
import script from "./AjusteVerbaList.vue?vue&type=script&lang=js&"
export * from "./AjusteVerbaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports